import types from './actionTypes';
import fetch from 'isomorphic-fetch';
import api from '../api';

/**
 * Synchronous Action creators
 */
let _products;
let nextTodoId = 0;
export const addTodo = text => ({
  type: types.ADD_TODO, 
  id: nextTodoId++,
  text 
});

export const toggleTodo = id => ({
  type: types.TOGGLE_TODO, 
  id 
});

export const setVisibilityFilter = filter => ({
  type: types.SET_VISIBILITY_FILTER, 
  filter 
});

export const selectSubreddit = subreddit => ({ 
  type: types.SELECT_SUBREDDIT, 
  subreddit 
});

export const invalidateSubreddit = subreddit => ({ 
  type: types.INVALIDATE_SUBREDDIT, 
  subreddit 
});

export const requestPosts = subreddit => ({ 
  type: types.REQUEST_POSTS, 
  subreddit 
});

export const receivePosts = (subreddit, json) => ({ 
  type: types.RECEIVE_POSTS, 
  subreddit, 
  posts: json.data.children.map(child => child.data), 
  receivedAt: Date.now() 
});

export const TIMEOUT = 100;
export const shop = {
  getProducts: (cb, timeout) => setTimeout(() => cb(_products), timeout || TIMEOUT),
  buyProducts: (payload, cb, timeout) => setTimeout(() => cb(), timeout || TIMEOUT)
};
  
export const receiveProducts = products => ({
  type: types.RECEIVE_PRODUCTS,
  products: products
});

export const getAllProducts = () => dispatch => {
  shop.getProducts(products => {
    dispatch(this.receiveProducts(products))
  })
};

export const addToCartUnsafe = productId => ({
  type: types.ADD_TO_CART,
  productId
});

export const addToCart = productId => (dispatch, getState) => {
  if (getState().products.byId[productId].inventory > 0) {
    dispatch(addToCartUnsafe(productId))
  }
};

export const checkout = products => (dispatch, getState) => {
  let cart = getState();
  dispatch({type: types.CHECKOUT_REQUEST})
  shop.buyProducts(products, () => {
    dispatch({
      type: types.CHECKOUT_SUCCESS,
      cart
    })
    // Replace the line above with line below to rollback on failure:
    // dispatch({ type: types.types.CHECKOUT_FAILURE, cart })
  })
};

/**
 * Asynchronous Action creators 异步Action
 * Thunk action creators 
 */
export const fetchPosts = (subreddit) => { 
  return dispatch => { 
    dispatch(requestPosts(subreddit)) //发送请求时显示状态
    return fetch(api.reddit + `/${subreddit}.json`) 
      .then(
        response => response.json(),
        error    => console.log("系统内部错误：", error)
      ) 
      .then(json => 
        dispatch(receivePosts(subreddit, json))
      ) 
  }
};

export const shouldFetchPosts = (state, subreddit) => { 
  let posts = state.postsBySubreddit[subreddit] 
  if (!posts) { 
    return true 
  } else if (posts.isFetching) { 
    return false 
  } else { 
    return posts.didInvalidate 
  }
};

export const fetchPostsIfNeeded = (subreddit) => { 
  return (dispatch, getState) => { 
    if (shouldFetchPosts(getState(), subreddit)) { 
      return dispatch(fetchPosts(subreddit)) 
    } 
  }
};



// WEBPACK FOOTER //
// ./usr/lib/ui/src/actions/index.js